import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageBanner from '../../components/PageBanner';
import { getBlogs } from '../../services/data.service';

const API_BASE = process.env.REACT_APP_DATABASEURL || '';

// Normalize a backend blog doc to the shape this page renders (uses `id`).
const normalize = (b) => ({ ...b, id: b.blogId || b.id });

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Load blog content from the backend (collection).
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getBlogs();
        const list = res?.data;
        if (active && Array.isArray(list)) {
          setBlogs(list.map(normalize));
        }
      } catch (e) {
        if (active) setBlogs([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const [featuredBlog, ...otherBlogs] = blogs;

  return (
    <>
      <Header />
      <PageBanner
        title="Insights & Updates"
        eyebrow="NCET Pulse"
        subtitle="Latest news, academic insights, and student stories from Nagarjuna College of Engineering and Technology. Stay connected with our campus life and technical achievements."
      />
      <div className="blog-page-root">
        {loading ? (
          <div className="container" style={{ padding: '6rem 0', textAlign: 'center', color: '#53545b' }}>
            Loading articles…
          </div>
        ) : blogs.length === 0 ? (
          <div className="container" style={{ padding: '6rem 0', textAlign: 'center', color: '#53545b' }}>
            No articles are available right now. Please check back later.
          </div>
        ) : (
          <>
        {featuredBlog && (
          <section className="blog-featured-section">
            <div className="container">
              <div className="blog-section-label">
                <span>Featured Story</span>
              </div>
              <Link to={`/blog/${featuredBlog.id}`} className="blog-feature-card">
                <div className="blog-feature-card__content">
                  <span className="blog-feature-card__badge">{featuredBlog.category}</span>
                  <div className="blog-feature-card__meta">
                    <time>{featuredBlog.date}</time>
                    <span className="blog-feature-card__dot" aria-hidden="true" />
                    <span>{featuredBlog.readTime}</span>
                  </div>
                  <h2>{featuredBlog.title}</h2>
                  <p>{featuredBlog.excerpt}</p>
                  <div className="blog-feature-card__footer">
                    <span className="blog-feature-card__author">By {featuredBlog.author}</span>
                    <span className="blog-feature-card__cta">
                      Read article
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </section>
        )}

        <section className="blog-articles-section">
          <div className="container">
            <div className="blog-section-head">
              <div>
                <span className="blog-section-head__eyebrow">Latest</span>
                <h2>Recent Articles</h2>
              </div>
              <p>Academics, placements, and campus life from across NCET.</p>
            </div>

            <div className="blog-articles-grid">
              {otherBlogs.map((blog) => (
                <Link to={`/blog/${blog.id}`} className="blog-article-card" key={blog.id}>
                  <div className="blog-article-card__body">
                    <span className="blog-article-card__category">{blog.category}</span>
                    <div className="blog-article-card__meta">
                      <time>{blog.date}</time>
                      <span>{blog.readTime}</span>
                    </div>
                    <h3>{blog.title}</h3>
                    <p>{blog.excerpt}</p>
                    <span className="blog-article-card__link">
                      Continue reading
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
          </>
        )}

        <section className="blog-cta-section">
          <div className="container">
            <div className="cta-box">
              <div className="cta-content">
                <h2>Discover What Makes NCET Different</h2>
                <p>Explore programs, campus culture, and student achievements through our academic and community updates.</p>
                <div className="cta-buttons">
                  <Link to="/admission-process" className="btn-apply">Apply Now</Link>
                  <Link to="/contact" className="btn-contact">Contact Us</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
